import React from 'react';

import classes from './ShowMiniLoader.module.css';

const showLoader = (props) => {

    let classList = [classes.MiniLoader];
    if (props.transparentBg) { classList.push(classes.TransparentBg) };
    if (props.forDropdown) { classList.push(classes.DropdownLoader) }

    const renderView = props.isLoading ?
        <div className={classList.join(' ')}>
            <svg width="51px" height="18px" viewBox="0 0 51 50">
                <rect y="0" width="11" height="50" fill="#0096ff">
                    <animate attributeName="height" values="50;10;50" begin="0s" dur="1s" repeatCount="indefinite" />
                    <animate attributeName="y" values="00;20;00" begin="0s" dur="1s" repeatCount="indefinite" />
                </rect>
                <rect x="19" y="0" width="11" height="18" fill="#0072ff">
                    <animate attributeName="height" values="50;10;50" begin="0.2s" dur="1s" repeatCount="indefinite" />
                    <animate attributeName="y" values="00;20;00" begin="0.2s" dur="1s" repeatCount="indefinite" />
                </rect>
                <rect x="38" y="0" width="11" height="18" fill="#0048ff">
                    <animate attributeName="height" values="50;10;50" begin="0.4s" dur="1s" repeatCount="indefinite" />
                    <animate attributeName="y" values="00;20;00" begin="0.4s" dur="1s" repeatCount="indefinite" />
                </rect>
            </svg>
        </div> : null;
    return renderView;
}

export default showLoader;